import React from "react";

const statusClass = (status) => {
  if (["APPROVED", "ACTIVE"].includes(status)) return "is-success";
  if (["REJECTED", "DELETED"].includes(status)) return "is-danger";
  if (["REUPLOAD_REQUIRED", "BLOCKED"].includes(status)) return "is-warning";
  return "is-info";
};

const AccountStatusBadge = ({ status, label }) => (
  <span className={`account-status-badge ${statusClass(status)}`}>
    <span aria-hidden="true" />
    {label || status || "—"}
  </span>
);

export default AccountStatusBadge;
